<div class="home-page-container">
  <div class="trial-start-guide" *ngIf="isTrialUser">
    <cc-trial-start-guide></cc-trial-start-guide>
  </div>
  <div class="activity-list-wrapper animate-fade-in">
    <cc-activity-list
      [title]="title"
      (onLoadMore)="loadActivities()"
      [noMoreActivities]="noMoreActivities"
      [showTeam]="true"
      (onClickThumbnail)="handleThumbnailClick()"
      (onClickFormLink)="handleClickFormLink()"
      (onClickTemplateLink)="handleClickTemplateLink()"
      (onClickDashboardLink)="handleClickDashboardLink()"
      [showProject]="true"
      [loading]="loadingActivities"
      [activities]="activities"
    ></cc-activity-list>
  </div>
</div>
